import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=de28c928&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=de28c928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de28c928",
  null
  
)

export default component.exports